import { Component } from '@angular/core';

@Component({
  selector: 'app-floating-whatsapp',
  templateUrl: './floating-whatsapp.component.html',
  styleUrls: ['./floating-whatsapp.component.scss']
})
export class FloatingWhatsappComponent {

}
